var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones26X26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 10.6641C5.64616 10.6641 4.62109 11.6891 4.62109 12.9492V19.1445C4.62109 20.4046 5.64616 21.4297 6.90625 21.4297C8.16634 21.4297 9.19141 20.4046 9.19141 19.1445V12.9492C9.19141 11.6891 8.16634 10.6641 6.90625 10.6641Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09766 12.9492C3.09766 12.7295 3.12665 12.5172 3.16255 12.3076C2.24453 12.6043 1.57422 13.4571 1.57422 14.4726V17.6211C1.57422 18.6366 2.24453 19.4894 3.16255 19.7861C3.12665 19.5765 3.09766 19.3642 3.09766 19.1445V12.9492Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 10.6641C17.8337 10.6641 16.8086 11.6891 16.8086 12.9492V19.1445C16.8086 20.4046 17.8337 21.4297 19.0938 21.4297C19.3228 21.4297 19.5397 21.3856 19.7484 21.3226C19.4649 22.2626 18.6014 22.9531 17.5703 22.9531H15.1448C14.8293 22.0684 13.9918 21.4297 13 21.4297C11.7399 21.4297 10.7148 22.4548 10.7148 23.7148C10.7148 24.9749 11.7399 26 13 26C13.9918 26 14.8293 25.3613 15.1448 24.4766H17.5703C19.6703 24.4766 21.3789 22.7679 21.3789 20.668V19.1445V12.9492C21.3789 11.6891 20.3538 10.6641 19.0938 10.6641Z",
    fill: "#4B9BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8379 12.3076C22.8738 12.5172 22.9028 12.7295 22.9028 12.9492V19.1445C22.9028 19.3642 22.8738 19.5765 22.8379 19.7861C23.7559 19.4894 24.4262 18.6366 24.4262 17.6211V14.4726C24.4262 13.4571 23.7559 12.6043 22.8379 12.3076Z",
    fill: "#4B9BF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C6.69947 0 1.57422 5.12525 1.57422 11.4258V11.4452C2.02805 11.1016 2.55313 10.8502 3.13254 10.7376C3.48857 5.59868 7.77227 1.52344 13 1.52344C18.2277 1.52344 22.5114 5.59868 22.8675 10.7376C23.4468 10.8502 23.9719 11.1016 24.4258 11.4452V11.4258C24.4258 5.12525 19.3005 0 13 0Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones26X26);
export default __webpack_public_path__ + "static/media/headphones_26x26.dfeadaf80bd63b7ce93a532ecd194002.svg";
export { ForwardRef as ReactComponent };